import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import SubscriptionIncludedApps from "../components/SubscriptionIncludedApps";

function SubscriptionInfo({ endDate, remainingDays }) {
  const daysLabel = remainingDays === 1 ? "день" : remainingDays >= 2 && remainingDays <= 4 ? "дня" : "дней";

  return (
    <div className="subscription-info-card">
      <div className="subscription-info-card__summary">
        <span className="subscription-info-card__icon" aria-hidden="true">
          <CheckOutlined />
        </span>
        <div>
          <div className="subscription-info-card__status">Подписка активна</div>
          <div className="subscription-info-card__details">
            <span>
              до {endDate ? new Date(endDate).toLocaleDateString("ru-RU") : "—"}
            </span>
            {remainingDays > 0 && <span>{remainingDays} {daysLabel}</span>}
          </div>
        </div>
      </div>
      <SubscriptionIncludedApps className="subscription-apps-strip--active" />
    </div>
  );
}

export default SubscriptionInfo;
